<template>
  <div style="background: #02133E !important">
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div>
    
    <div class="col-lg-7 col-12 mx-auto p-0 d-flex main-image-wrapper" style="margin-top: -30px;">
            <b-carousel
                id="carousel-1"
                :interval="6000"
                controls
                fade
                style="text-shadow: 1px 1px 2px #333; width: 100%; height: 100%; padding: 10px;"
                v-if="!threedData.embedded_link && !threedData.isLive"
            >
                <b-carousel-slide
                    img-src="https://storage.googleapis.com/spacetech2/gold549/malay-gold.webp"
                ></b-carousel-slide>
            </b-carousel>
        </div>

    <div style="padding-left: 10px; padding-right: 10px;">
      <NoticeBar
        class="col-lg-12 col-12 mx-auto notice-bar"
        scrollable
        :text="websiteInfo[0]?.noticeText"
        v-if="!threedData.embedded_link && !threedData.isLive"
      />
    </div>

    <div class="col-12 account-container-wrapper d-flex py-1 my-2">
      <div class="col-lg-6 col-5 my-auto">
        <img src="https://cdn.gold549.com/build/assets/img/theme/profile.png" style="width: 92px; height: 92px" alt="">
      </div>

      <div class="col-lg-6 col-7 p-0">
        <div class="pt-2">
          <div class="d-flex">
            <p class="css-17h40hp mb-1" style="width: 85px;"> 
                        {{ $t('home.name') }}</p>
            <p class="css-eurmd1 mb-1" style="color: #000000; font-weight: 400;">: {{$store.state.authUser.name}} </p>
          </div>
          <div class="d-flex">
            <p class="css-17h40hp mb-1" style="width: 85px">
                        {{ $t('home.balance') }}</p>
            <p class="css-eurmd1 mb-1" style="color: #000000; font-weight: 400;">:
              <b>{{ Number($store.state.amount).toLocaleString() }}</b>
              {{ $t('common.currency') }}
            </p>
          </div>
          <div class="d-flex">
            <p class="css-17h40hp mb-1" style="width: 85px">
                        {{ $t('home.phoneShort') }}</p>
            <p class="css-eurmd1 mb-1" style="color: #000000; font-weight: 400;">: {{ $store.state.authUser.phone }} </p>
          </div>
          <div class="d-flex">
            <p class="css-17h40hp mb-1" style="width: 85px">
                        {{ $t('home.withdraw') }}</p>
            <p class="css-eurmd1 mb-1" style="color: #000000; font-weight: 400;">:
              {{ Number($store.state.totalWithdraw).toLocaleString() }}
              {{ $t('common.currency') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="justify-content-center cards-container-mobile">
      <div
        class="col-xl-6 col-6 home-cards pr-1"
        @click="redirectRoute('body-fb')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/body.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
                {{ $store.state.language === 'en' ? 'Body' : 'ဘော်ဒီ' }}
            </h4>
          </div>
        </div>
      </div>

      <div
        class="col-xl-6 col-6 home-cards pl-1"
        @click="redirectRoute('maung-fb')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/maung.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{ $store.state.language === 'en' ? 'Maung' : 'မောင်း' }}
            </h4>
          </div>
        </div>
      </div>

      <div
        class="col-xl-6 col-6 home-cards pr-1"
        @click="redirectRoute('betslip-history')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/old_vouchers.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{
                $store.state.language === 'en'
                  ? 'Voucher List'
                  : 'လောင်းထားသောပွဲများ'
              }}
            </h4>
          </div>
        </div>
      </div>
      <div
        class="col-xl-6 col-6 home-cards pl-1"
        @click="redirectRoute('history')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/transaction.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{
                $store.state.language === 'en'
                  ? 'Transactions'
                  : 'ငွေစာရင်းများ'
              }}
            </h4>
          </div>
        </div>
      </div>


      <div
        class="col-xl-6 col-6 home-cards pr-1"
        @click="redirectRoute('deposit')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/deposit.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{
                $store.state.language === 'en'
                  ? 'Deposit'
                  : 'ငွေသွင်းရန်'
              }}
            </h4>
          </div>
        </div>
      </div>

      <div
        class="col-xl-6 col-6 home-cards pl-1"
        @click="redirectRoute('withdraw')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/withdraw.png"
              alt=""
              style="width: auto; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{
                $store.state.language === 'en'
                  ? 'Withdraw'
                  : 'ငွေထုတ်ရန်'
              }}
            </h4>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-6 home-cards pr-1" @click="redirectRoute('setting')">
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/setting.png"
              alt=""
              style="width: 30px; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              {{ $store.state.language === 'en' ? 'Setting' : 'ကိုယ်ရေးအချက်အလက်' }}
            </h4>
          </div>
        </div>
      </div>

      <div
        class="col-xl-6 col-6 home-cards pl-1"
        @click="redirectRoute('Live')"
      >
        <div
          class="card d-flex justify-content-center align-items-center mb-2 pt-2"
          style="width: 100%; height: 65px; border-radius: 5px"
        >
          <div>
            <img
              src="https://cdn.gold549.com/build/assets/img/theme/live.png"
              alt=""
              style="width: 30px; height: 30px"
            />
          </div>
          <div class="pt-1">
            <h4>
              Live
            </h4>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-end px-0">
        <div
          class="col-3 home-cards pl-1 mr-0 mt-4 mb-3"
          @click="logout()"
        >
          <div
            class="card d-flex flex-row justify-content-center align-items-center mb-2 py-2 px-2"
          >
              <img
                src="https://cdn.gold549.com/build/assets/img/theme/logout.png"
                alt=""
                style="width: 20px; height: 20px"
              />
            <div>
              <p class="css-38745a pl-2" style="color: #000000; font-weight: 400;">Log out</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</template>
<script>
import { NoticeBar, Dialog, Toast } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { NoticeBar },
  data() {
    return {
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {},
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
    async redirectRoute(path) {
      try {
        if (path === 'tip') {
          const text =
            this.$store.state.language === 'en'
              ? 'This feature is not support yet.'
              : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === 'en' ? 'Okay' : 'Okay',
          }).then(() => {
            // on close
          });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    console.log('home')
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    console.log(authUser)
    this.fetchWebsiteData();
    this.fetchUser();
    // this.fetchTwoDdata();
    // this.fetchThreedDdata();
    // this.fetchTwoThreeDHistories();
  },
};
</script>
<style scoped>
.css-38745a {
    margin: 0px;
    line-height: 1.5;
    font-size: 12px;
    /* font-family: NotoSansMyanmar; */
    font-weight: 500;
}
.css-17h40hp {
    margin: 0px;
    line-height: 1.5;
    font-size: 14px;
    /* font-family: NotoSansMyanmar; */
    font-weight: 700 !important;
}
.card {
  cursor: pointer;
  border-radius: 10px !important;
}
.main-image-wrapper img {
  width: 100%;
}
.video-container {
  height: 500px;
  width: 100%;
}
.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: #000000;
  font-weight: 500;
  background: rgba(255, 242, 0, 0.7);
}
.twod-threed-cards {
  height: 200px;
}
.live-number {
  font-weight: bold;
  font-size: 25px;
}
.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.not-live-text {
  font-weight: bold;
  font-size: 24px;
}
.cards-container {
  display: flex;
  flex-wrap: wrap;
}
.card-body {
  padding: 0px !important;
}
.cards-container-mobile {
  display: none;
}
@keyframes live-number-animation {
  from {
    color: white;
  }
  to {
    color: red;
  }
}

/* @media (max-width: 768px) { */
  .middle-container {
    padding-top: 0.1rem !important;
  }
  hr {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .video-container {
    height: 300px;
    width: 100%;
  }
  .main-wrapper {
    padding: 7px !important;
  }
  .notice-bar {
    margin-top: 0px;
    height: 25px;
    z-index: 1;
    font-size: 12px;
    color: #02133E;
    background: white;
    border-radius: 7px;
  }
  .live-number {
    font-weight: bold;
    font-size: 20px;
  }
  .live-result {
    font-weight: bolder;
    font-size: 37px;
  }

  .cards-container {
    display: none;
  }
  .cards-container-mobile {
    padding: 0px !important;
    margin-top: 5px !important;
    display: flex;
    flex-wrap: wrap;
  }
  .home-cards {
    padding-left: 10px;
    padding-right: 10px;
  }
  .card-body {
    padding: 0px !important;
  }
  .not-live-text {
    font-size: 18px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .account-container-wrapper {
    width: auto;
    height: auto;
    border-radius: 10px;
    padding-left: 4px;
    padding-right: 4px;
    margin: 10px;
    color: black;
    background: #ffffff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
  .top-wrapper,
  .bottom-wrapper {
    padding: 10px;
    width: 100%;
    display: flex;
  }
  .top-right,
  .bottom-right {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: end;
  }
  .top-left,
  .bottom-left {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: start;
  }
/* } */
</style>
